<template>
  <div class="product-info-box w-100">
    <div class="row" :class="stateView ?`px-2` : `p-4`">
      <div :class="stateView ?`d-none` : `col-12`">
        <div class="d-flex align-content-center justify-content-between">
          <span v-t="`product.single.store_name`"/>
          <span class="product-info-box-name">
            {{ authorName }}
          </span>
        </div>
        <hr/>
      </div>
      <div class="" :class="stateView ?`d-none` : `col-12 mt-4`">
        <slot></slot>
      </div>
      <div class="col-12 mt-4">
        <div class="product-info-box-btn" :class="stateView ?`d-flex justify-content-between` : ``">
          <div :class="stateView ? `order-3` : `` ">
            <m-product-price200 class="text-center mb-3 product-card-312-price" :product="product"/>
          </div>
          <div class="text-center   ">

            <m-single-product-price3 class="product-info-box-price-section text-center"
                                     :class="stateView ? `order-4` : ``"
                                     :product="product"/>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import mProductPrice200 from "../../ProductPrice200.vue";
import mA from "../../../Tags/A.vue";
import mSingleProductPrice3 from "../../SingleProductPrice3/SingleProductPrice3.vue";

export default {
  name: "ProductInfoBox.vue",
  components: {mSingleProductPrice3, mA, mProductPrice200},
  methods: {findAttributeOnSiteInfo},
  props: {
    product: {},
    stateView: {
      default: false,
      type: Boolean,
    },
    productAuthor: {
      default: false,
      type: Boolean,
    }
  },
  computed: {
    authorName() {
      if(this.productAuthor && Object.keys(this.product).length  > 0){
        return  this.product.user.name
      }
      //todo:add exeption when user is not a store print siteinfo main store
      return findAttributeOnSiteInfo('site_name')[0]
    }
  }
}
</script>

<style scoped>
.product-info-box-name {
  font-weight: bolder;
}

.product-info-box {
  background-color: rgba(238, 238, 241, 0.97);
  border-radius: 9px;
  font-size: .85rem;
}

.product-info-box .product-info-box-price-section :deep(.normal-product-offer),
.product-info-box .product-info-box-price-section :deep(.normal-product-price) {
  display: none;
}

.product-info-box .product-info-box-price-section :deep(.normal-product-button-main) {
  width: 100%;
  margin: 0 !important;
  padding: 10px 15px;
}


.product-info-box .product-info-box-price-section :deep(.normal-product-button-section .my-5) {
  margin: 0 0 10px 0 !important;
}


</style>